import React, { useState } from 'react';
import Slider from 'react-slick';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { WebsiteImage } from 'components/TitleDescription';
import InPageFeaturesCtaButton from '../InPageFeaturesV3/InPageFeaturesV3FeaturedContent/InPageFeaturesCtaButton';
import WistiaVideo from 'components/Core/WistiaVideo';
import Mp4Video from '../Mp4Video';

import { Container } from './styles';

const MobileCarousel = ({ backgroundColor, inPageNavigation, title }) => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  return (
    <Container
      className="in-page-features--content-mobile-container"
      background={backgroundColor}
      title={title}
    >
      <div className="in-page-features--navigation-content">
        <Slider
          asNavFor={nav2}
          ref={slider => setNav1(slider)}
          slidesToShow={1}
          swipeToSlide
          focusOnSelect
          centerMode
          arrows={false}
          variableWidth
        >
          {inPageNavigation.map((item, index) => {
            return (
              <>
                <div className="in-page-features--navigation-item" key={index}>
                  <h2 className="in-page-features--navigation-item-title">{item.title}</h2>
                </div>
              </>
            );
          })}
        </Slider>
      </div>

      <div className="in-page-features--main-content">
        <Slider asNavFor={nav1} ref={slider => setNav2(slider)} arrows dots>
          {inPageNavigation.map((item, index) => {
            let featuredImage;
            const featuredMp4 = item.featuredImage?.image?.file?.contentType === 'video/mp4';
            if (!featuredMp4) {
              featuredImage = item.featuredImage?.image || item.featuredImage || item.sideImage;
            }
            const { featuredVideo } = item;

            return (
              <>
                {featuredMp4 && (
                  <div className="in-page-features--video-content">
                    <Mp4Video src={item.featuredImage?.image?.file?.url} />
                  </div>
                )}
                {featuredImage && (
                  <div className="in-page-features--image-content">
                    <WebsiteImage src={featuredImage} alt={item.featuredImage?.alt} />
                  </div>
                )}
                {featuredVideo && (
                  <div className="in-page-features--video-content">
                    <WistiaVideo dataPosition="In-Page Features" {...featuredVideo} />
                  </div>
                )}
                <div className="in-page-features--description-content" key={index}>
                  {item.description && (
                    <div className="in-page-features--description-content-container">
                      {documentToReactComponents(item.description.json)}
                      {item.link && <InPageFeaturesCtaButton to={item.link} />}
                    </div>
                  )}
                </div>
              </>
            );
          })}
        </Slider>
      </div>
    </Container>
  );
};

export default MobileCarousel;
